<div class="db-carousel" [ngClass]="{'left-aligned': !!leftAlign}">
  <div class="db-carousel__body" [ngStyle]="{height: height + 'px'}">
    <div class="db-carousel__item" *ngFor="let item of items; let index = index"
         [ngClass]="{'current': checked === index, 'next': checked + 1 === index}">
      <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{item: item}"></ng-container>
    </div>
  </div>

  <div class="db-carousel__nav {{navAdditionalClass}}" *ngIf="!withProgressBar">
    <div *ngFor="let item of items;  let i = index" (click)="checked = i; percentageLeft = 0" [ngClass]="{'current': checked === i}"></div>
  </div>
  <div class="db-carousel__nav {{navAdditionalClass}}" *ngIf="!!withProgressBar">
    <ng-container *ngFor="let item of items;  let i = index">
      <db-progress-bar
        *ngIf="checked === i"
        [size]="'m'" [state]="'gray'"
        [progressPercent]="percentageLeft">
      </db-progress-bar>
      <div (click)="checked = i; percentageLeft = 0" [ngClass]="{'current': checked === i}" *ngIf="checked !== i"></div>
    </ng-container>
  </div>
</div>
